export default  (Vue)=>{
    Vue.prototype.$test = "自用插件prototype测试数据"
}